import { BookingWidget } from "@/components/site/BookingWidget";

export const Hero = ({ config }) => (
  <section id="hero" className="relative overflow-hidden border-b border-white/10 pb-20 pt-12 md:pb-28 md:pt-20" data-testid="hero-section">
    <div className="pointer-events-none absolute inset-0 opacity-20">
      <div className="h-full w-full bg-[radial-gradient(#38bdf8_1px,transparent_1px)] [background-size:32px_32px]"></div>
    </div>

    <div className="relative z-10 mx-auto max-w-6xl px-6">
      <div className="mb-14 flex flex-col justify-between gap-12 lg:flex-row lg:items-end">
        <div className="max-w-3xl">
          <div className="mb-6 inline-flex items-center gap-2.5 rounded-full border border-[#38bdf8]/30 bg-[#38bdf8]/10 px-3 py-1 font-mono-lbl text-xs uppercase tracking-widest text-[#38bdf8]" data-testid="hero-dispatch-badge">
            <span className="h-2 w-2 animate-ping rounded-full bg-[#38bdf8]"></span>
            <span>Live Dispatch &middot; Leeds Bradford &amp; North UK</span>
          </div>

          <h1 className="font-disp text-5xl uppercase leading-[0.92] text-white sm:text-7xl lg:text-8xl" data-testid="hero-headline">
            <span className="ln"><span>FLIGHT TRACKED</span></span>
            <span className="ln"><span className="bg-gradient-to-r from-white via-slate-200 to-[#38bdf8] bg-clip-text text-transparent">AIRPORT TRANSFERS</span></span>
            <span className="ln"><span>GUARANTEED CALM</span></span>
          </h1>

          <p className="d1-fade-sub mt-6 max-w-xl text-lg leading-relaxed text-slate-300 sm:text-xl" data-testid="hero-subline">
            Fixed prices with zero hidden extras for Yorkshire families and holidaymakers heading to Leeds Bradford, Manchester and all regional terminals.
          </p>
        </div>

        <div className="d1-fade-sub flex-shrink-0 rounded-2xl border border-white/10 bg-slate-900/80 p-6 backdrop-blur-md lg:w-72" data-testid="hero-metrics-card">
          <div className="mb-2 font-mono-lbl text-xs uppercase text-slate-400">Verified Reliability</div>
          <div className="flex items-center gap-1 font-disp text-4xl text-white">
            <span>&pound;</span>
            <span className="text-[#38bdf8]">0</span>
            <span className="ml-2 font-mono-lbl text-xs font-normal text-slate-400">SURCHARGES</span>
          </div>
          <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-4 font-mono-lbl text-xs text-slate-300">
            <span>FLIGHT DELAY COVER</span>
            <span className="text-[#38bdf8]">100% INCLUDED</span>
          </div>
        </div>
      </div>

      <BookingWidget config={config} />
    </div>
  </section>
);
